import { useEffect, useState } from "react";
import { startSignIn, getLastAuthError } from "../firebase";
import { Screen, ScreenHeader, Display, Lede, Btn, InlineSpinner } from "../ui/components";
import { Ico } from "../ui/Ico";
import { C } from "../ui/tokens";

export function SignIn() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // A failed redirect sign-in (unauthorized domain, network error, account
  // conflict, …) is only observable inside currentSession()'s call to
  // getRedirectResult, which runs long before this screen mounts — surface
  // whatever it found rather than bouncing the user back here in silence.
  // Read via an effect, not a useState lazy initializer: the initializer
  // form is invoked twice by React.StrictMode in dev, and since reading is
  // consuming (getLastAuthError clears the slot), the second call would see
  // it already empty. The `if (stashed)` guard means a second effect
  // invocation that reads nothing never clears an error already shown.
  useEffect(() => {
    const stashed = getLastAuthError();
    if (stashed) setError(stashed);
  }, []);

  async function go() {
    setBusy(true);
    setError(null);
    try {
      await startSignIn();
    } catch {
      setBusy(false);
      setError("Anmeldung fehlgeschlagen. Bitte erneut versuchen.");
    }
  }

  return (
    <Screen>
      <ScreenHeader title="Spesen · Anmeldung" />
      <Display>Bitforge<br />Spesen</Display>
      <Lede>Melde dich mit deinem Bitforge-Konto an.</Lede>

      <div style={{ marginTop: 32 }}>
        <Btn
          onClick={go}
          disabled={busy}
          icon={busy ? <InlineSpinner /> : <Ico name="arrow" size={18} color="#000" />}
        >
          Mit Google anmelden
        </Btn>
        {error && (
          <p style={{ marginTop: 16, fontSize: 13, color: C.fg2 }}>{error}</p>
        )}
      </div>

      <p style={{ marginTop: 24, fontSize: 12, color: C.fg3 }}>
        Nur Konten mit einer @bitforge.ch-Adresse haben Zugriff.
      </p>
    </Screen>
  );
}
